import  'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import { useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import SplashAuthPage from './pages/SplashAuthPage';
import AuthPage from './pages/AuthPage';
import HelpPage from './pages/HelpPage';
import LogoutPage from "./components/Auth/Logout";
import SessionsPage from './pages/SessionsPage';
import SessionInfoPage from './pages/SessionInfoPage';
import SessionComparisonPage from './pages/SessionComparisonPage';
import GameLibraryPage from './pages/GameLibraryPage';
import GameInfoPage from './pages/GameInfoPage';
import UserSettingsPage from './pages/UserSettingsPage';

import InformationPage from './pages/InformationPage';
import AuthContext from './store/auth-context';

import UserProfile from './components/Profile/UserProfile';
import PatientContext from "./store/patient-context";
import PatientSelectionPage from "./pages/PatientSelectionPage";
import TermsOfUsePage from "./pages/TermsOfUsePage";
import PrivacyPage from "./pages/PrivacyPage";
import LearnMorePage from "./pages/LearnMorePage";
import MissingPage from "./pages/MissingPage";
import ForgotPassword from "./components/Auth/ForgotPasswordForm";
import ResetPassword from "./components/Auth/ResetPasswordForm";
import AdminPage from "./pages/AdminPage";
import FacilitatorAppPage from "./pages/FacilitatorAppPage";


function App() {
  const authCtx = useContext(AuthContext);
  const patientCtx = useContext(PatientContext);
  const loggedInWithPatient = authCtx.isLoggedIn && (patientCtx.patientId !== '');
  const isAdmin = authCtx.userRole === 'admin'

  return (
      <BrowserRouter>
        <Routes>
          {/*<Route path='/' element={<HomePage/>}/>*/}
          <Route path='/' element={<SplashAuthPage/>}/>
          <Route path='auth' element={<AuthPage/>}/>
          <Route path='forgotpassword' element={<ForgotPassword/>}/>
          <Route path='resetpassword' element={<ResetPassword/>}/>
          <Route path='logout' element={<LogoutPage/>}/>

          <Route path='learnmore' element={<LearnMorePage/>}/>
          <Route path='privacy' element={<PrivacyPage/>}/>
          <Route path='termsofuse' element={<TermsOfUsePage/>}/>
          <Route path="help" element={<HelpPage />}/>
          <Route path="missing" element={<MissingPage />}/>

          {authCtx.isLoggedIn && <Route path='patient_selection' element={<PatientSelectionPage />} />}
          {loggedInWithPatient && <Route path="sessions" element={<SessionsPage />} />}
          {loggedInWithPatient && <Route path="session_info/:sessionId" element={<SessionInfoPage />} />}
          {loggedInWithPatient && <Route path="session_comparison/:sessionId01/:sessionId02" element={<SessionComparisonPage />} />}

          {loggedInWithPatient && <Route path="games" element={<GameLibraryPage />} />}
          {loggedInWithPatient && <Route path="game/:gameId" element={<GameInfoPage />} />}
          {loggedInWithPatient && <Route path="game_startup/:gameId/:sessionId" element={<FacilitatorAppPage />} />}
          {loggedInWithPatient && <Route path="profile" element={<UserProfile />} />}
          {loggedInWithPatient && <Route path="about" element={<InformationPage />} />}
          {loggedInWithPatient && <Route path="help" element={<HelpPage />} />}
          {loggedInWithPatient && <Route path="user_settings" element={<UserSettingsPage />} />}

          {isAdmin && <Route path="admin" element={<AdminPage />} />}

          <Route path="*" element={
            (loggedInWithPatient && <Navigate to="sessions" replace />) ||
            (authCtx.isLoggedIn && <Navigate to="patient_selection" replace />) ||
            <Navigate to="/auth" replace />
          } />
        </Routes>
      </BrowserRouter>
  );
}

export default App;
